import { API, graphqlOperation } from "aws-amplify";
import {
  createEventLocationLookup,
  updateEventLocationLookup
} from "../graphql/mutations";
import { getEventLocationLookup } from "./../graphql/queries";

export class Location {
  async createLocation({ id }, { addressLine1, addressLine2, town, postcode }) {
    const {
      data: { createEventLocationLookup: result }
    } = await API.graphql(
      graphqlOperation(createEventLocationLookup, {
        input: {
          addressLine1: addressLine1,
          addressLine2: addressLine2,
          town: town,
          postcode: postcode,
          createdAt: new Date().toISOString(),
          eventLocationLookupEventCompanyId: id,
          isDeleted: 0
        }
      })
    );
    return result;
  }

  async updateLocation({ id, addressLine1, addressLine2, town, postcode }) {
    const {
      data: { updateEventLocationLookup: result }
    } = await API.graphql(
      graphqlOperation(updateEventLocationLookup, {
        input: {
          id: id,
          addressLine1: addressLine1,
          addressLine2: addressLine2,
          town: town,
          postcode: postcode,
          isDeleted: 0
        }
      })
    );
    return result;
  }

  async getLocationsByCompany({ id }) {
    const getEventCompany = `query GetEventCompany($id: ID!) {
      getEventCompany(id: $id) {
        eventLocationLookup(filter: {isDeleted: {eq: 0}}) {
          items {
            id
            postcode
            town
            addressLine1
            addressLine2
            createdAt
            isDeleted
          }
        }
      }
    }`;
    try {
      const {
        data: {
          getEventCompany: {
            eventLocationLookup: { items: result }
          }
        }
      } = await API.graphql(
        graphqlOperation(getEventCompany, {
          id: id
        })
      );
      return result;
    } catch (err) {
      throw new Error(err.message);
    }
  }

  async deleteLocation({ id }) {
    try {
      const {
        data: { updateEventLocationLookup: result }
      } = await API.graphql(
        graphqlOperation(updateEventLocationLookup, {
          input: {
            id: id,
            isDeleted: 1
          }
        })
      );
      return result;
    } catch (err) {
      throw new Error(err.message);
    }
  }

  async getLocationById({ id }) {
    try {
      const {
        data: { getEventLocationLookup: result }
      } = await API.graphql(
        graphqlOperation(getEventLocationLookup, {
          id: id
        })
      );
      return result;
    } catch (err) {
      throw new Error(err.message);
    }
  }
}
